module.exports = require("./ga-IE.js");